import { render, staticRenderFns } from "./EditPendaftaran.vue?vue&type=template&id=5bc784e2&"
import script from "./EditPendaftaran.vue?vue&type=script&lang=js&"
export * from "./EditPendaftaran.vue?vue&type=script&lang=js&"
import style0 from "./EditPendaftaran.vue?vue&type=style&index=0&id=5bc784e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports